// Segregated preview route group for the screen-simulation harness.
// Gated to dev and explicit QA builds (lib/qaBuild). Not linked from
// app navigation. Static previews force LIGHT theme (restored on exit); the
// visual suite and attack-log gallery control their own theme.
// See apps/mobile/preview/README.md.
import { Redirect, Stack, usePathname } from 'expo-router'
import React from 'react'
import { useTheme, type ThemeMode } from '../../hooks/useTheme'
import { isQaBuild } from '../../lib/qaBuild'

function ForceLightTheme() {
  const { theme, setTheme } = useTheme()
  const original = React.useRef<ThemeMode | null>(null)
  React.useEffect(() => {
    if (original.current === null) original.current = theme
    setTheme('light')
    return () => {
      if (original.current) setTheme(original.current)
    }
    // Run once on mount / restore on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export default function DevLayout() {
  const pathname = usePathname()
  // QA features are selected at bundle time; see docs/local-qa.md.
  if (!isQaBuild()) return <Redirect href="/" />
  return (
    <>
      {!pathname.includes('/preview/visual-suite') && !pathname.includes('/preview/attack-log-concepts') && !pathname.includes('/preview/card-set-concepts') && !pathname.includes('/preview/desktop-home-concepts') && !pathname.includes('/preview/logo-easter-egg') && <ForceLightTheme />}
      <Stack screenOptions={{ headerShown: true, title: 'Preview · Screen previews' }} />
    </>
  )
}
